import { Toaster } from "sonner";
import { Header } from "../components/Header";
import { MonthlyPricePulse } from "../components/MonthlyPricePulse";
import { Footer } from "../components/Footer";

/**
 * Dedicated route for the Monthly Bulletin so the Shop-page CTA has a
 * hard URL (`/rates-bulletin`) that always works, bypassing the fragile
 * `/#monthly-price-pulse` hash-scroll dance.
 */
export default function RatesBulletin() {
  return (
    <main className="bg-[#070707] text-[#F5F5F0]">
      <Toaster position="bottom-right" theme="dark" richColors />
      <Header />
      <div className="pt-24">
        <MonthlyPricePulse />
      </div>
      <Footer />
    </main>
  );
}
